import React from 'react';
import { DragHandle } from '@mui/icons-material';
import { ListItemIcon, Radio } from '@mui/material';
import { Checkbox } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { combinedColor, OPACITY_MEDIUM, PLAIN_GREY } from '~/Constants/Colors.constants';

interface IFitoListItemMainActionProps {
  listName: string;
  index: number;

  disabled?: boolean;
  checked?: boolean;

  onCheckboxChecked: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;

  hasAPicture?: boolean;
  checkable?: boolean;
  multiSelect?: boolean;
  isBeingRearranged?: boolean;
}

const useStyles = (hasAPicture?: boolean) =>
  makeStyles({
    listChecklist: {
      marginLeft: 0,
      height: 42,
      color: combinedColor(PLAIN_GREY, OPACITY_MEDIUM),
      '& >span': {
        padding: hasAPicture ? 9 : 'inherit',
      },
    },
    dragHandler: {
      minWidth: 30,
      height: 42,
      alignItems: 'center',
    },
  });

export const FitoListItemMainAction = ({
  listName,
  index,
  disabled,
  checked,
  onCheckboxChecked,
  hasAPicture,
  checkable,
  multiSelect,
  isBeingRearranged,
}: IFitoListItemMainActionProps) => {
  const { classes } = useStyles(hasAPicture)();

  if (isBeingRearranged) {
    return (
      <ListItemIcon className={classes.dragHandler} data-testid="dragButton">
        <DragHandle />
      </ListItemIcon>
    );
  }
  if (!checkable) {
    return null;
  }
  if (multiSelect) {
    return (
      <Checkbox
        edge="start"
        checked={checked}
        value={checked}
        inputProps={{ 'aria-labelledby': `${listName}-${index}` }}
        onChange={onCheckboxChecked}
        disabled={disabled}
        className={classes.listChecklist}
        data-testid="checkButton"
      />
    );
  }
  return <Radio checked={checked} />;
};
